<template>
    <div class="data-content">
        <div class="img-card" v-for="(item,index) in pageImgs" :key="index" @click="cardClick(item)" >
            <div class="catdbox" v-if="item.name!=''">
                <img :src=item.imgUrl />
                <div class="name" v-if="item.name!=''">{{item.name}}</div>
                <!-- <view class="bottom" v-if="item.name!=''">
                    <view>查看详情</view>
                </view> -->
            </div>
            
        </div>	
        <gpaging :sumCount="imgs.length" onePageCount="8"  @setIndex ="setPage"></gpaging>
    </div>
</template>

<script>
 import gpaging from "../paging.vue";
export default {
   components:{
        gpaging
   },
    data() {
		return {
            imgs:[
                {
                    id:'0',
                    name:'曹莉',
                    imgUrl:'images/team_introduce/01.jpg'
                },
                {
                    id:'1',
                    name:'苑秀明',
                    imgUrl:'images/team_introduce/02.jpg'
                },
                {
                    id:'2',
                    name:'乌日图宝音',
                    imgUrl:'images/team_introduce/03.jpg'
                },
                {
                    id:'3',
                    name:'崔金玲',
                    imgUrl:'images/team_introduce/04.jpg'
                },
                {
                    id:'4',
                    name:'郑国华',
                    imgUrl:'images/team_introduce/05.jpg'
                },
                {
                    id:'5',
                    name:'李纳',
                    imgUrl:'images/team_introduce/06.jpg'
                },
                {
                    id:'6',
                    name:'王智睿',
                    imgUrl:'images/team_introduce/07.jpg'
                },
                {
                    id:'7',
                    name:'杨利民',
                    imgUrl:'images/team_introduce/08.jpg'
                },
                {
                    id:'8',
                    name:'辛晨旭',
                    imgUrl:'images/team_introduce/09.jpg'
                },
                {
                    id:'9',
                    name:'赵媛',
                    imgUrl:'images/team_introduce/10.jpg'
                }
            ],
            pageImgs:[],
            pageIndex :0
		}
    },
    methods:{
        cardClick(item){
            this.$router.push({path:'/team_introduce_details',query: {id:item.id}})
        },
        setPage(index){
            this.pageIndex = index;
            this.updateImgs();
        },
        updateImgs(){
            this.pageImgs = [];
            let startIndex = this.pageIndex*8;
            let endIndex = startIndex+8;
            for(startIndex;startIndex<endIndex;startIndex++){
                if(this.imgs[startIndex]!=undefined){
                    this.pageImgs.push(this.imgs[startIndex])
                }else{
                    this.pageImgs.push({
                        name:'',
                        imgUrl:''
                    })
                }
                    
            }
        }
    },
    onLoad() {
       
    },
    created(){
        console.log("ok");
        this.updateImgs();
    }
}
</script>

<style lang="scss" scoped>
.data-content{
    height: 655pxl;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .img-card{
        height: 286px;
        width: 200px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
            width: 171px;
            height: 234px;
        }
        .name{
            text-align: center;
            font-weight: 600;
            font-size: 1.6ch;
            margin: 8px 0;
        }
        .bottom{
            width: 100%;
            text-align: right;
            margin-right: 20px;
            font-size: 0.8ch;
            font-weight: 700;
            color: #999;
        }
    }
    .img-card:hover{
        cursor: pointer;
    }

}
</style>
